import i18n from '../../lang/index'
import util from '../../utils/util'
i18n.locale = util.getCookie("locale") || 'en';
const ipRouter = [{
  path: '/ip',
  component: () => import('@/pages/Index'),
  redirect: {
    name: 'ipindex'
  },
  children: [{
      name: 'ipindex',
      path: 'index',
      component: () => import('@/pages/ip/Index'),
      redirect: {
        name: 'antiddos'
      },
      children: [{
          name: 'antiddos',
          path: 'antiddos',
          meta: {
            tab: 'antiddos',
            title: i18n.t('defense.titles.antiDdosIP')
          },
          component: () => import('@/pages/ip/AntiDDoS'),
        },
        {
          name: 'web',
          path: 'web',
          meta: {
            tab: 'web',
            title: i18n.t('defense.titles.web')
          },
          component: () => import('@/pages/ip/WebSite'),
        },
        {
          name: 'layer4',
          path: 'layer4',
          meta: {
            tab: 'layer4',
            title: i18n.t('defense.titles.nonweb')
          },
          component: () => import('@/pages/ip/NonWebSite'),
        }
      ]
    },
    {
      name: 'antset',
      path: 'antiddos/set',
      meta: {
        tab: 'antset',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/IPSetView'),
    },
    {
      name: 'ipdetail',
      path: 'antiddos/detail',
      meta: {
        tab: 'ipdetail',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/IPView'),
    },
    {
      name: 'domset',
      path: 'web/set',
      meta: {
        tab: 'domset',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/DomainSetView'),
    },
    {
      name: 'layer4set',
      path: 'layer4/set',
      meta: {
        tab: 'layer4set',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/Layer4SetView'),
    },
    {
      name: 'frequencyRules',
      path: 'rule/frequency',
      meta: {
        tab: 'frequencyRules',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/FrequencyRules'),
    },
    {
      name: 'preciseRules',
      path: 'rule/precise',
      meta: {
        tab: 'preciseRules',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/PreciseRules'),
    },
    {
      name: 'accelerationRules',
      path: 'rule/acceleration',
      meta: {
        tab: 'accelerationRules',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/AccelerationRules'),
    },
    {
      name: 'refreshUrl',
      path: 'set/refresh',
      meta: {
        tab: 'refreshUrl',
        title: i18n.t('defense.titles.antiDdosIP')
      },
      component: () => import('@/pages/ip/RefreshCache'),
    },
    {
      name: 'logindex',
      path: 'log',
      component: () => import('@/pages/ip/IndexLog'),
      redirect: {
        name: 'fulllog'
      },
      children: [{
        name: 'fulllog',
        path: 'fullLog',
        meta: {
          tab: 'fullLog',
          title: i18n.t('defense.titles.fullLog')
        },
        component: () => import('@/pages/ip/FullLog'),

      }, {
        name: 'Visitslog',
        path: 'visits',
        meta: {
          tab: 'visits',
          title: i18n.t('defense.titles.ipVisits')
        },
        component: () => import('@/pages/ip/VisitsLog'),
      }, {
        name: 'Regionlog',
        path: 'region',
        meta: {
          tab: 'region',
          title: i18n.t('defense.titles.ipRegionRanking')
        },
        component: () => import('@/pages/ip/RegionLog'),
      }, {
        name: 'Ranklog',
        path: 'rank',
        meta: {
          tab: 'rank',
          title: i18n.t('defense.titles.ipRanking')
        },
        component: () => import('@/pages/ip/RankLog'),
      }, {
        name: 'Urllog',
        path: 'url',
        meta: {
          tab: 'url',
          title: i18n.t('defense.titles.urlLog')
        },
        component: () => import('@/pages/ip/UrlLog'),
      },{
        name: 'FeaturesLog',
        path: 'features',
        meta: {
          tab: 'features',
          title: i18n.t('defense.titles.featuresLog')
        },
        component: () => import('@/pages/ip/FeaturesLog'),
      }, {
        name: 'LayerLog',
        path: 'layerlog',
        meta: {
          tab: 'layerlog',
          title: i18n.t('defense.titles.layerLog')
        },
        component: () => import('@/pages/ip/LayerLog'),
      }, {
        name: 'LayerChart',
        path: 'layerchart',
        meta: {
          tab: 'layerchart',
          title: i18n.t('defense.titles.layerChart')
        },
        component: () => import('@/pages/ip/LayerChart'),
      }, {
        name: 'AttackLog',
        path: 'attack',
        meta: {
          tab: 'attack',
          title: i18n.t('defense.titles.attackLog')
        },
        component: () => import('@/pages/ip/AttackLog'),
      }, ]
    },
  ]
}]
export default ipRouter



// WEBPACK FOOTER //
// ./src/router/modules/ip.js